module.exports = __webpack_public_path__ + "img/Completely-Off-The-Grid.5beb52d5.jpg";